import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class MonitoringReportsService extends RestfulService<Models.MonitoringReport> {

  constructor(public restService: RestService) {
    super(Models.MonitoringReport);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('monitoring-reports');
  }

}
